export default function Standard_Deviation() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Standard_Deviation</h1>
      <p>Content for Standard_Deviation goes here.</p>
    </div>
  );
}